import {endpoint} from 'services/Api';
import {RESOURCE as PARENT} from 'services/api/calculatorModals';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'heads-of-loss';

/**
 * Heads of Loss Modal Endpoints:
 *     - Bereavement Award Modal Endpoint.
 */
export default {
    /**
     * Bereavement Award Modal Endpoint.
     *
     * @return {Promise}
     */
    bereavementAward: data => endpoint(`${PARENT}/${RESOURCE}`, 'bereavement-award', data, false),
};



// WEBPACK FOOTER //
// ./src/services/api/calculatorModals/headsOfLoss.js